// src/pages/Terms.tsx
import React from "react";

export default function Terms() {
  React.useEffect(() => {
    window.location.replace("https://www.nimos.cloud/terms");
  }, []);

  return null;
}
